import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText
} from '@mui/material'
export const ModalError = (props) => {
    const { onClose, open, error , lang} = props;
    const handleClose = () => {
        onClose();
    };
    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle color={"red"}>Error - {error?.response?.data?.error_code || error?.response?.status || error?.result?.status || error?.status}</DialogTitle>
            <DialogContent>
                <DialogContentText >
                    {error?.response?.data?.[`message_${lang}`] || error?.response?.data?.error_message || error?.response?.data?.message || error?.result?.message || error?.message}
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}
